/*
 * @Author: zjg
 * @Date: 2020-04-14 15:14:33
 * @LastEditTime: 2020-04-29 17:47:55
 * @Deccription: 新手引导的状态存储，后期打算封闭成类
 */
import _$ from 'js/api/getdata'
import TYPES from '../types'

export const featureGuideState = {
  guideArr: [ // 多个新手引导状态
    {
      guideKey: 'upmenu', // 新手引导组件key值
      isShow: false, // 新手引导显隐状态
      ignore: false, // 是否忽略
    },
    {
      guideKey: 'fullscreen',
      isShow: false,
      ignore: false,
    },
  ],
  guideInfo: '',
}

export const featureGuideMutations = {
  /**
    * 新手引导显隐逻辑判断
    */
  [TYPES.GET_AFTER_GUIDE](state, data) { // data为新手引导组件的key
    if (data.state === 'start' && data.arr.length === 0) { // 判断当前是否为页面初次加载
      for (let i = 0; i < state.guideArr.length; i += 1) { // 循环遍历数组，将第一个未被忽略的引导显示
        if (state.guideArr[i].ignore === false) {
          state.guideArr[i].isShow = true
          break
        }
      }
    } else if (data.state === 'start' && data.arr.length !== 0) { // 请求接口，新手引导有多个，但未全部点击
      for (let i = 0; i < state.guideArr.length; i += 1) { // 将已关闭的引导的下一个未忽略引导显示
        if (state.guideArr[i].guideKey === data.arr[0]
          && (i !== state.guideArr.length - 1)
          && state.guideArr[i + 1].ignore === false) {
          state.guideArr[i + 1].isShow = true
          break
        }
      }
    } else {
      for (let i = 0; i < state.guideArr.length; i += 1) { // 点击关闭后的回调，只有一个参数，将已关闭的下一个未忽略的引导显示
        if (state.guideArr[i].guideKey === data
          && (i !== state.guideArr.length - 1)
          && state.guideArr[i + 1].ignore === false) { // 判断关闭的新手引导，并且打开下一个
          state.guideArr[i + 1].isShow = true // 显隐状态设为true
          break
        } else { // 如果是最后一个，直接关闭
          state.guideArr[i].isShow = false
        }
      }
    }
  },
  [TYPES.SET_GUIDE_INFO](state, data) {
    state.guideInfo = data
  },
}

export const featureGuideActions = {
  /**
    * 初始化新手引导状态
    */
  getGuide({ commit, state }) { // 多个新手引导时
    _$.getData('getFeatureGuide', { bubbleType: 'preview' })
      .then(({ data }) => {
        // const keysArr = Object.keys(res.data) // 接口返回对象的键值数组  // TODO:后期删除
        // commit('GET_AFTER_GUIDE', { state: 'start', arr: keysArr }) // 调用设置函数  // TODO:后期删除
        const { previewBubbleContent } = data
        let bubbleInfo = {}
        if (previewBubbleContent) {
          bubbleInfo = JSON.parse(previewBubbleContent)
        }
        const bubbleInfoKeyArray = Object.keys(bubbleInfo)
        commit('SET_GUIDE_INFO', JSON.stringify(data))
        // localStorage.setItem('bubble', JSON.stringify(data)) // 列表项目中所有bubble信息需要一起传回，所以存入localStorage
        const arr = [] // 为了沿用GET_AFTER_GUIDE 的方法，此处整合需要的数据
        let stateValue = 'start'
        if (bubbleInfoKeyArray.includes('upmenu')) { // 当返回的新手引导的信息包含了upmenu,即为已经点了查看类型
          arr.push('upmenu')
        }
        if (bubbleInfoKeyArray.includes('fullscreen')) { // 当返回的新手引导的信息包含了fullscreen,即为已经点了全屏
          stateValue = ''
          arr.push('fullscreen')
        }
        commit('GET_AFTER_GUIDE', {
          state: stateValue,
          arr,
        })
      }, () => { // 接口挂掉，所有引导全都不显示
        for (let i = 0; i < state.guideArr.length; i += 1) {
          state.guideArr[i].isShow = false
        }
      })
  },
}
